<template>
    <div class="">
         <div class="d-flex align-items-center justify-content-between">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" v-if="$store.getters.user?.role !== 'Team lead'"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">Reports</li>
                </ol>
                <label class="form-label"> <h4>Reports</h4></label>
            </div>
            <div class="d-flex align-items-center">
                <div class="report-tabs me-3" role="tablist">
                    <button type="button" class="report-tab" :class="{ active: tab === 'marketing' }" @click="setTab('marketing')">Marketing</button>
                    <button type="button" class="report-tab" :class="{ active: tab === 'staff' }" @click="setTab('staff')">Non Marketing</button>
                </div>
                <button class="btn d-flex align-item-center btn-success" @click="downloadExcel"><i class="ri-download-line me-1"></i>Download Report</button>
            </div>
        </div>
        <div class="card br-16 card-shadow">
            <div class="card-body">
                <template v-if="tab === 'marketing'">
                <div class="row mb-2">
                    <div class="col-md-2 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <div><label class="form-label">District</label></div>
                            <a type="button" class="text-danger me-2" @click="reset('district')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->


                        <!-- <Search
                            :class="{ 'is-invalid': errors?.district_id }"
                            :customClass="{ 'is-invalid': errors?.district_id }"
                            :initialize="meta.district_id"
                            id="district_id"
                            label="district"
                            placeholder="Select District"
                            :data=" districts"
                            @input=" district => meta.district_id = district"
                            @selectsearch="getSchools(meta.district_id)"
                        >
                        </Search> -->

                         <Search
                            :class="{ 'is-invalid': errors?.district_id }"
                            :customClass="{ 'is-invalid': errors?.district_id }"
                            :initialize="meta.district_id"
                            id="district_id"
                            label="district"
                            placeholder="Select District"
                            :data=" districts"
                            @input=" district => meta.district_id = district"
                            @selectsearch="updateDistrictID(meta.district_id)"
                        >
                        </Search>


                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <div><label class="form-label">School</label></div>
                            <a type="button" class="text-danger me-2" @click="reset('school')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->
                         <SchoolSearch
                            @selectSearch="checkInitalDistrict($event)"
                            :district_ids="district_ids"
                            :initialize="meta.school_name"
                            @selectSchool="selectSchool($event)"
                            ref="school_id"
                            :class="{ 'is-invalid': errors.district_error }"
                        >
                        </SchoolSearch>
                        <span v-if="errors.district_error" class="invalid-feedback">{{ errors.district_error }}</span>
                         <!-- <Search
                            :class="{ 'is-invalid': errors?.school_id }"
                            :customClass="{ 'is-invalid': errors?.school_id }"
                            :initialize="meta.school_id"
                            id="school_id"
                            label="school_name"
                            placeholder="Select School"
                            :data=" schools"
                            @input=" school => meta.school_id = school"
                        >
                        </Search> -->
                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <label class="form-label">Users</label>
                            <a type="button" class="text-danger me-2" @click="reset('users')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->
                        <Search
                            :class="{ 'is-invalid': errors?.user_id }"
                            :customClass="{ 'is-invalid': errors?.user_id }"
                            :initialize="meta.user_id"
                            id="user_id"
                            label="name"
                            placeholder="Select User"
                            :data="marketingReportUsers"
                            @input=" user => meta.user_id = user"
                        >
                        </Search>
                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <label class="form-label">Board</label>
                            <a type="button" class="text-danger me-2" @click="reset('board')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->
                        <select class="form-control" v-model="meta.board">
                            <option value="">Select Board</option>
                            <option value="CBSC">CBSC</option>
                            <option value="ICSC">ICSC</option>
                            <option value="State">State</option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <label class="form-label">Stages</label>
                            <a type="button" class="text-danger me-2" @click="reset('stages')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->
                        <select class="form-control" :class="{ 'is-invalid': errors.stage }" v-model="meta.stage_id" >
                            <option value="">Select Stages</option>
                            <option v-for="stage, key in stages" :key="key" :value="stage.stage_id">{{stage.stage}}</option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-3">
                        <label class="form-label">KG Strength</label>
                        <VueSlider
                            v-model="value"
                            :min="0"
                            :max="1000"
                            :interval="10"
                            contained
                        />
                        <span v-if="errors.kg_strength" class="invalid-feedback">{{ errors.kg_strength[0] }}</span>
                    </div>
                    <div class="col-md-3 mb-3">
                        <!-- <div class="d-flex justify-content-between">
                            <label class="form-label">From To Date</label>
                            <a type="button" class="text-danger me-2" @click="reset('from_to_date')"><i class="ri-close-line fs-20 lh-1"></i></a>
                        </div> -->
                        <flatPickr class="form-control" placeholder="Select Date Range" ref="flatpickr"
                            :class="{ 'is-invalid': errors?.date_time }" v-model="meta.date_time"
                            :config="config" @onChange="getSelectedDates" >
                        </flatPickr>
                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <label class="form-label">From Date</label> -->
                        <input class="form-control" type="number" :class="{ 'is-invalid': errors.pincode }" placeholder="Pincode" v-model="meta.pincode">
                        <span v-if="errors.pincode" class="invalid-feedback">{{ errors.pincode[0] }}</span>
                    </div>
                    <div class="col-md-2 mb-3">
                        <!-- <label class="form-label">Place</label> -->
                        <input class="form-control" type="text" :class="{ 'is-invalid': errors.place }" placeholder="Place" v-model="meta.place">
                        <span v-if="errors.place" class="invalid-feedback">{{ errors.place[0] }}</span>
                    </div>
                    <div class="col-md-2 mb-3">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="isLatest" v-model="meta.is_latest">
                            <label class="form-check-label" for="isLatest">
                                Latest Entries
                            </label>
                        </div>
                    </div>
                    <div class="col-md-2 mb-3">
                        <button type="button" @click="search" class="btn btn-primary me-2">Search</button>
                        <button type="button" @click="reset()" class="btn btn-danger"><i class="ri-close-line lh-1"></i></button>
                    </div>
                </div>
                <div class="table-responsive table-responsive-sm" style="height: 330px; overflow: scroll;">
                    <table class="table table-sm text-nowrap table-bordered mb-0">
                        <thead>
                            <tr v-if="filteredSessionForms.length == 0">
                                <th class="text-center">Sl.No</th>
                                <th>User</th>
                                <th>School Name</th>
                                <th>KG Strength</th>
                                <th>Place</th>
                                <th>Address</th>
                                <th>Visited Date</th>
                                <th>Present Stage</th>
                                <th>Next Stage</th>
                                <th>Status</th>
                                <th>Remark</th>
                                <th>Priority</th>
                                <th>Next Reminder Date & Time</th>
                                <th class="text-center">Actions</th>
                            </tr>
                            <tr v-else>
                                <th class="text-center sticky-col col-0 sticky">Sl.No</th>
                                <!-- <th @click="sort('user_name')" class="sticky-col col-1 sticky">
                                    User
                                    <span>
                                        <i v-if="meta.keyword == 'user_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'user_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('school_name')" class="sticky-col col-2 sticky">
                                    School Name
                                    <span>
                                        <i v-if="meta.keyword == 'school_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'school_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th class="sticky-col col-3 sticky">
                                    KG Strength
                                </th>
                                <th @click="sort('place')">
                                    Place
                                    <span>
                                        <i v-if="meta.keyword == 'place' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'place' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('address')">
                                    Address
                                    <span>
                                        <i v-if="meta.keyword == 'address' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'address' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('date_time')">
                                    Visited Date
                                    <span>
                                        <i v-if="meta.keyword == 'date_time' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'date_time' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th> -->
                                <th class="sticky-col col-1 sticky">User</th>
                                <th class="sticky-col col-2 sticky">School Name</th>
                                <th class="sticky-col col-3 sticky">KG Strength</th>
                                <th>Place</th>
                                <th>Address</th>
                                <th>Visited Date</th>
                                <th>Present Stage</th>
                                <th>Next Stage</th>
                                <th>Status</th>
                                <th>Remark</th>
                                <th>Priority</th>
                                <th>Next Reminder Date & Time</th>
                                <th class="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="filteredSessionForms.length == 0">
                                <td colspan="14" class="text-center">No records found</td>
                            </tr>
                            <tr v-for="(session_form, key) in filteredSessionForms" :key="key">
                                <td class="text-center sticky-col col-0 sticky">{{ meta.from + key }}</td>
                                <td class="sticky-col col-1 sticky">{{session_form?.User?.name}}</td>
                                <td class="sticky-col col-2 sticky text-wrap">{{ session_form?.School?.school_name}}</td>
                                <td class="sticky-col col-3 sticky">
                                    <span v-for="fields, key in session_form?.School?.SessionFields" :key="key">
                                        <span v-if="fields?.field_name == 'KG Strength'">{{ fields?.value }} </span>
                                    </span>
                                </td>
                                <td>{{ session_form?.School?.place }}</td>
                                <td>{{ session_form?.School?.address }}</td>
                                <td>{{ changeDate(session_form.date_time) }}</td>
                                <td>{{ session_form?.PresentStage?.stage }}</td>
                                <td>{{ session_form?.NextStage?.stage }}</td>
                                <td>{{ session_form?.status ? 'Completed' : 'Pending' }}</td>
                                <td>{{ session_form?.remarks }}</td>
                                <td>{{ formatPriority(session_form?.priority) }}</td>
                                <td>{{ changeDateTime(session_form?.reminder_date_time) }}</td>
                                <td class="text-center">
                                    <nav>
                                        <a data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="edit(session_form)" href="javascript:void(0)" class="text-success me-2"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                        <a @click.prevent="view(session_form)" href="javascript:void(0)" class="text-success me-2"><i class="ri-eye-line fs-18 lh-1"></i></a>
                                    </nav>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </template>
                <template v-else>
                    <div class="row mb-2 staff-filters">
                        <div class="col-md-3 mb-3">
                            <input class="form-control" type="text" placeholder="Search activity, status, or note" v-model="staffMeta.search" />
                        </div>
                        <div class="col-md-2 mb-3">
                            <Search
                                :key="staffSearchKey"
                                :class="{ 'is-invalid': errors?.user_id }"
                                :customClass="{ 'is-invalid': errors?.user_id }"
                                :initialize="staffMeta.user_id"
                                id="user_id"
                                label="name"
                                placeholder="Select User"
                                :data="marketingReportUsers"
                                @input="selectStaffUser"
                            >
                            </Search>
                        </div>
                        <div class="col-md-2 mb-3">
                            <input class="form-control" type="date" v-model="staffMeta.from_date" />
                        </div>
                        <div class="col-md-2 mb-3">
                            <input class="form-control" type="date" v-model="staffMeta.to_date" />
                        </div>
                        <div class="col-md-2 mb-3">
                            <button type="button" class="btn btn-primary me-2" @click="searchStaff">Submit</button>
                            <button type="button" class="btn btn-danger" @click="resetStaff"><i class="ri-close-line lh-1"></i></button>
                        </div>
                    </div>
                    <div class="table-responsive table-responsive-sm" style="height: 330px; overflow: scroll;">
                        <table class="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>Sr. No</th>
                                    <th>User</th>
                                    <th>Session Started</th>
                                    <th>Activity</th>
                                    <th>Status</th>
                                    <th>Reminder</th>
                                    <th>Activity Started</th>
                                    <th>Activity Ended</th>
                                    <th>Total Hours</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="!staffRows.length">
                                    <td colspan="9" class="text-center text-muted">No records found</td>
                                </tr>
                                <tr v-for="(row, rowIndex) in staffRows" :key="rowIndex">
                                    <td>{{ (staffMeta.from || 1) + rowIndex }}</td>
                                    <td>{{ row.user?.name || '-' }}</td>
                                    <td style="min-width: 180px; white-space: normal;">
                                        <div style="font-weight: 600;">{{ formatSessionTime(row.session.from_date_time) || '-' }}</div>
                                        <div class="text-muted">{{ row.session.note || '-' }}</div>
                                    </td>
                                    <td style="white-space: normal;">{{ row.activity?.activity_name || '-' }}</td>
                                    <td class="text-capitalize">{{ row.activity?.status || '-' }}</td>
                                    <td>{{ row.activity ? (formatReminder(row.activity.reminder) || '-') : '-' }}</td>
                                    <td>{{ activityStarted(row.activity) || '-' }}</td>
                                    <td>{{ activityEnded(row.activity) || '-' }}</td>
                                    <td>{{ activityTotalHours(row.activity) || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </div>
        </div>
         <div class="mt-3" v-if="tab === 'marketing'">
                <div class="d-flex justify-content-between align-items-center">
                    <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                    </select>
                    <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta?.totalRows }} entries</span>
                    <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                </div>
            </div>
         <div class="mt-3" v-else>
                <div class="d-flex justify-content-between align-items-center">
                    <select class="form-select from-select-sm width-75" v-model="staffMeta.per_page" @change="onStaffPerPageChange">
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                    </select>
                    <span>Showing {{ staffMeta.from }} to {{ staffMeta.to }} of {{ staffMeta.totalRows }} entries</span>
                    <Pagination :maxPage="staffMeta.maxPage" :totalPages="staffMeta.lastPage" :currentPage="staffMeta.page" @pagechanged="onStaffPageChange" />
                </div>
            </div>
    </div>
    <!-- Modal -->
<div class="modal fade" data-bs-backdrop='static' id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Update Stage</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeModal"></button>
      </div>
      <div class="modal-body">
        <label class="form-label">Reminder Date</label>
        <br>
        <!-- <input type="datetime-local" class="form-control" placeholder="Date Time" aria-label="Date Time" v-model="stage.reminder_date_time" aria-describedby="button-addon2"> -->
        <flatPickr
            class="form-control"
            placeholder="Select Reminder Date and Time"
            aria-label="Date Time"
            aria-describedby="button-addon2"
            :class="{ 'is-invalid': errors?.reminder_date_time }"
            v-model="stage.reminder_date_time"
            :config="{
                enableTime: true,
                dateFormat: 'd-m-Y H:i',
                allowInput: true,
                static: true
            }"
            style="width: 468px;">
        </flatPickr>
        <span v-if="errors.reminder_date_time" class="invalid-feedback">{{ errors.reminder_date_time}}</span>
        <br>
        <br>
        <label class="form-label">Present Stage</label>
        <select class="form-control" v-model="stage.stage_id" :class="{ 'is-invalid': errors.stage_id }">
            <option value="">Select Present Stage</option>
            <option v-for="stage, key in modalStages" :key="key" :value="stage.stage_id">{{ stage.stage }}</option>
        </select>
        <br>
        <label class="form-label">Next Stage</label>
        <select class="form-control" v-model="stage.next_stage_id" :class="{ 'is-invalid': errors.next_stage_id }">
            <option value="">Select Next Stage</option>
            <option v-for="stage, key in modalStages" :key="key" :value="stage.stage_id">{{ stage.stage }}</option>
        </select>
        <template v-if="canSetPriority">
          <br>
          <label class="form-label">Priority</label>
          <select class="form-control" v-model="stage.priority" :class="{ 'is-invalid': errors.priority }">
              <option value="">Select Priority</option>
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
              <option value="revisit">Revisit</option>
          </select>
        </template>
      </div>
      <div class="modal-footer">
        <button type="button" @click="saveStage()" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
    import SchoolSearch from "@/components/SchoolSearch.vue";
    import Pagination from "@/components/Pagination.vue";
    import Search from "@/components/Search.vue";
    // import moment from "moment";
    import moment from 'moment-timezone';
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import axios from 'axios';
    import VueSlider from 'vue-3-slider-component'
    export default {
        components: { Pagination, Search, SchoolSearch, flatPickr, VueSlider },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "desc",
                    keyword: "date_time",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                    district_id: "",
                    school_id: "",
                    school_name:"",
                    user_id: "",
                    board: "",
                    stage_id:"",
                    date_time:"",
                    from_date_time: "",
                    to_date_time: "",
                    kg_strength: "",
                    kg_strength_min: "",
                    kg_strength_max: "",
                    pincode: "",
                    place: "",
                    is_latest: false,
                },
                from_date_time: "",
                to_date_time: "",
                value: [0, 1000],
                stage: {
                    stage_id: "",
                    next_stage_id:"",
                    session_comment_id:"",
                    reminder_date_time:"",
                    priority: "",
                },
                stage_status: false,
                session_forms: [],
                districts: [],
                users: [],
                schools: [],
                stages:[],
                errors: [],
                district_ids: [],
                tab: "marketing",
                staffSearchKey: 0,
                staffRows: [],
                staffSearchTimer: null,
                staffMeta: {
                    search: "",
                    user_id: "",
                    from_date: moment().subtract(1, "days").format("YYYY-MM-DD"),
                    to_date: moment().format("YYYY-MM-DD"),
                    page: 1,
                    per_page: 10,
                    totalRows: 0,
                    lastPage: 1,
                    from: 0,
                    to: 0,
                    maxPage: 1,
                },
                config: {
                    mode:'range',
                    defaultDate: [],
                    dateFormat: 'd-m-Y',
                }
            };
        },
        mounted() {
            this.index();
            this.$nextTick(() => {
                if (this.from_date_time && this.to_date_time && this.$refs.flatpickr) {
                    this.$refs.flatpickr.fp.setDate([this.from_date_time, this.to_date_time]);
                }
            });
        },
        computed: {
            marketingReportUsers() {
                const matched = (this.users || []).filter((user) => user.attendance_type !== "non marketing");
                if (this.$store.getters.user?.role !== "Team lead") {
                    return matched;
                }
                const leadId = this.$store.getters.user?.user_id;
                const lead = matched.find((user) => String(user.user_id) === String(leadId));
                if (!lead) {
                    return matched;
                }
                return [lead, ...matched.filter((user) => String(user.user_id) !== String(leadId))];
            },
            filteredSessionForms() {
                if(this.meta.kg_strength){
                    return this.session_forms.filter((session_form) => {
                        // Ensure SessionFields exists and includes an object with field_name === 'KG Strength'
                        return session_form?.School?.SessionFields?.some(
                            (field) => field?.field_name === 'KG Strength' && field?.value
                        );
                    });
                }
                else{
                    return this.session_forms
                }
            },
            modalStages() {
                const selectedIds = [this.stage.stage_id, this.stage.next_stage_id]
                    .filter((id) => id !== "" && id != null)
                    .map((id) => Number(id));
                return this.stages.filter((stage) => !stage.deleted_at || selectedIds.includes(Number(stage.stage_id)));
            },
            isTeamLead() {
                return this.$store.getters.user?.role === "Team lead";
            },
            canSetPriority() {
                const role = this.$store.getters.user?.role;
                return role === "Team lead" || role === "Admin";
            },
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (from.name !== "SessionForm.View") {
                    return;
                }

                const saved = vm.$store.getters.report_search;
                vm.meta.district_id = saved?.district_id || "";
                vm.meta.school_id = saved?.school_id || "";
                vm.meta.school_name = saved?.school_name || "";
                vm.meta.user_id = saved?.user_id || "";
                vm.meta.stage_id = saved?.stage_id || "";
                vm.meta.board = saved?.board || "";
                vm.meta.pincode = saved?.pincode || "";
                vm.meta.place = saved?.place || "";
                vm.meta.is_latest = saved?.is_latest || false;
                vm.meta.kg_strength = saved?.kg_strength || "";
                vm.meta.date_time = saved?.date_time || "";
                vm.from_date_time = saved?.from_date_time || "";
                vm.to_date_time = saved?.to_date_time || "";
                vm.meta.kg_strength_min = saved?.kg_strength_min !== "" ? saved.kg_strength_min : 0;
                vm.meta.kg_strength_max = saved?.kg_strength_max !== "" ? saved.kg_strength_max : 1000;
                vm.value = [vm.meta.kg_strength_min, vm.meta.kg_strength_max];
                vm.district_ids = saved?.district_id ? [saved.district_id] : [];
                vm.config.defaultDate = [vm.from_date_time, vm.to_date_time].filter(Boolean);
                vm.meta.page = vm.$store.getters.current_page || 1;
            });
        },
        methods: {
            setTab(tab) {
                if (this.tab === tab) {
                    return;
                }
                this.tab = tab;
                if (tab !== "staff") {
                    return;
                }
                const selectedStaffUser = this.staffMeta.user_id && this.marketingReportUsers.some((user) => String(user.user_id) === String(this.staffMeta.user_id));
                if (!selectedStaffUser) {
                    this.staffMeta.user_id = "";
                }
                this.staffMeta.page = 1;
                this.staffSearchKey += 1;
                this.fetchStaffActivities();
            },
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            selectStaffUser(userId) {
                this.staffMeta.user_id = userId;
            },
            searchStaff() {
                if (!this.staffMeta.from_date || !this.staffMeta.to_date) {
                    this.$store.dispatch("error", "Select from date and to date");
                    return;
                }
                this.staffMeta.page = 1;
                this.fetchStaffActivities();
            },
            resetStaff() {
                this.staffMeta.search = "";
                this.staffMeta.user_id = "";
                this.staffMeta.from_date = moment().subtract(1, "days").format("YYYY-MM-DD");
                this.staffMeta.to_date = moment().format("YYYY-MM-DD");
                this.staffMeta.page = 1;
                this.staffSearchKey += 1;
                this.fetchStaffActivities();
            },
            onStaffPageChange(page) {
                this.staffMeta.page = page;
                this.fetchStaffActivities();
            },
            onStaffPerPageChange() {
                this.staffMeta.page = 1;
                this.fetchStaffActivities();
            },
            fetchStaffActivities() {
                let vm = this;
                if (!vm.staffMeta.from_date || !vm.staffMeta.to_date) {
                    return;
                }
                const payload = {
                    search: vm.staffMeta.search || "",
                    page: vm.staffMeta.page,
                    per_page: vm.staffMeta.per_page,
                    from_date_time: moment(vm.staffMeta.from_date).format("YYYY-MM-DD"),
                    to_date_time: moment(vm.staffMeta.to_date).format("YYYY-MM-DD"),
                };
                if (vm.staffMeta.user_id) {
                    payload.user_id = vm.staffMeta.user_id;
                }
                vm.$store.dispatch("post", { uri: "marketingActivity/paginateReportActivities", data: payload })
                .then(function (response) {
                    const body = response.data.data || {};
                    vm.staffRows = body.data || [];
                    vm.staffMeta.totalRows = body.meta?.total || 0;
                    vm.staffMeta.lastPage = body.meta?.lastPage || 1;
                    vm.staffMeta.from = body.meta?.from || 0;
                    vm.staffMeta.to = body.meta?.to || 0;
                    vm.staffMeta.maxPage = vm.staffMeta.lastPage >= 3 ? 3 : vm.staffMeta.lastPage;
                })
                .catch(function (error) {
                    vm.errors = error.response?.data?.errors;
                    vm.$store.dispatch("error", error.response?.data?.message || "Request failed");
                });
            },
            formatReminder(reminder) {
                if (!reminder) {
                    return "";
                }
                const parsed = moment(reminder);
                return parsed.isValid() ? parsed.format("DD-MM-YYYY hh:mm:ss A") : reminder;
            },
            formatSessionTime(date_time) {
                if (!date_time) {
                    return "";
                }
                const parsed = moment(date_time);
                return parsed.isValid() ? parsed.format("DD-MM-YYYY hh:mm:ss A") : "";
            },
            activityStarted(activity) {
                if (!activity?.created_at) {
                    return "";
                }
                return this.formatSessionTime(activity.created_at);
            },
            activityEnded(activity) {
                if (!activity || String(activity.status || "").toLowerCase() !== "completed" || !activity.updated_at) {
                    return "";
                }
                return this.formatSessionTime(activity.updated_at);
            },
            activityTotalHours(activity) {
                if (!activity || String(activity.status || "").toLowerCase() !== "completed" || !activity.created_at || !activity.updated_at) {
                    return "";
                }
                const start = moment(activity.created_at);
                const end = moment(activity.updated_at);
                if (!start.isValid() || !end.isValid() || !end.isAfter(start)) {
                    return "";
                }
                const totalMinutes = end.diff(start, "minutes");
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;
                if (hours > 0 && minutes > 0) {
                    return `${hours}h ${minutes}m`;
                }
                if (hours > 0) {
                    return `${hours}h`;
                }
                return `${minutes}m`;
            },
            changeDate(date_time){
                return moment(date_time).format("DD-MM-YYYY hh:mm:ss A");
            },
            changeDateTime(date_time) {
                // console.log('date_time:----', date_time)
                return moment.utc(date_time).format("DD-MM-YYYY hh:mm:ss A");
                // return moment.tz(date_time, "Asia/Kolkata").utc().format("DD-MM-YYYY hh:mm:ss")
            },
            changeDateTimeMeta(date_time) {
                return moment(date_time, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
            },
            changeDateMeta(date_time){
                return moment(date_time).format("DD-MM-YYYY hh:mm:ss");
            },
            getSelectedDates(dates){
				let vm = this;
				vm.from_date_time = moment(dates[0]).format("DD-MM-YYYY")
				vm.to_date_time = moment(dates[1]).format("DD-MM-YYYY")
			},
            saveReportSearch() {
                let vm = this;
                vm.$store.commit("setReportSearch", {
                    district_id: vm.meta.district_id,
                    school_id: vm.meta.school_id,
                    school_name: vm.meta.school_name,
                    user_id: vm.meta.user_id,
                    stage_id: vm.meta.stage_id,
                    board: vm.meta.board,
                    pincode: vm.meta.pincode,
                    place: vm.meta.place,
                    is_latest: vm.meta.is_latest,
                    kg_strength: vm.meta.kg_strength,
                    kg_strength_min: vm.value[0],
                    kg_strength_max: vm.value[1],
                    from_date_time: vm.from_date_time,
                    to_date_time: vm.to_date_time,
                    date_time: vm.meta.date_time,
                });
            },
            index() {
                let vm = this;
                vm.meta.kg_strength_min = vm.value[0];
                vm.meta.kg_strength_max = vm.value[1];
                vm.saveReportSearch();
                if(vm.from_date_time && vm.to_date_time){
                    vm.meta.from_date_time = vm.changeDateTimeMeta(vm.from_date_time)
                    vm.meta.to_date_time = vm.changeDateTimeMeta(vm.to_date_time)
                }
                vm.$store.dispatch("post", { uri: "session/paginateSessionForms", data: vm.meta })
                .then(function (response) {
                    vm.session_forms = response.data.data.data;
                    vm.meta.totalRows = response.data.data.meta.total;
                    vm.meta.lastPage = response.data.data.meta.lastPage;
                    vm.meta.from = response.data.data.meta.from;
                    const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                    vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    if (!vm.stage_status) {
                        vm.getDistricts();
                    }
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            getDistricts() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store.dispatch("post", { uri: "district/getAllDistricts" })
                .then((response) => {
                    // console.log("distt", response.data.data);
                    loader.hide();
                    vm.districts = response.data.data;
                    vm.getUsers();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            updateDistrictID(value) {
                this.district_ids = [];
                this.district_ids.push(value);
            },
            getSchools(value) {
                let vm = this;
                let loader = vm.$loading.show();
                let district_ids = [];
                district_ids.push(value);
                vm.$store.dispatch("post", { uri: "school/districtSchool", data: { district_ids: district_ids } })
                .then((response) => {
                    loader.hide();
                    // console.log("r00--", response.data.data);
                    vm.schools = response.data.data.data;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            getUsers() {
                let vm = this;
                let loader = vm.$loading.show();
                const usersUri = vm.$store.getters.user?.role === "Team lead" ? "users/getTeamLeadEmployees" : "users/getUsers";
                vm.$store.dispatch("post", { uri: usersUri })
                .then((response) => {
                    loader.hide();
                    vm.users = response.data.data;
                    vm.getStages();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            getStages(){
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store.dispatch("post", { uri: "stages/getStage" })
                .then((response) => {
                    loader.hide();
                    vm.stages = response.data.data;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            saveStage() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store.dispatch("post", { uri: "session/UpdateSeesionSatge",data: vm.stage })
                .then((response) => {
                    loader.hide();
                    // console.log("rr--", response)
                    vm.stage_status = true;
                    vm.$store.dispatch("success", response.data.message);
                    document.getElementById("closeModal").click();
                    vm.index();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            view(session_form) {
                this.saveReportSearch();
                this.$store.commit("setCurrentPage", parseInt(this.meta.page))
                this.$router.push("/session_forms/" + session_form.School.school_id + "/view");
            },
            formatPriority(priority) {
                if (!priority) {
                    return "";
                }
                return String(priority).charAt(0).toUpperCase() + String(priority).slice(1);
            },
            edit(session_form) {
                // console.log("session_form", session_form)

                this.stage.stage_id = session_form.stage_id ? session_form.stage_id : '';
                this.stage.next_stage_id = session_form.next_stage_id ? session_form.next_stage_id : "";
                this.stage.reminder_date_time = session_form.reminder_date_time ? moment.utc(session_form.reminder_date_time).format("DD-MM-YYYY hh:mm:ss") : "";
                this.stage.session_comment_id = session_form.session_comment_id;
                this.stage.priority = session_form.priority ? session_form.priority : "";
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
            reset(){
                let vm = this;
                vm.district_ids = [];
                vm.meta.district_id = ""
                vm.meta.school_id =  ""
                vm.meta.school_name = ""
                vm.meta.user_id =  ""
                vm.meta.board = ""
                vm.meta.stage_id = ""
                vm.meta.date_time = ""
                vm.meta.from_date_time = ""
                vm.meta.to_date_time = ""
                vm.from_date_time = ""
                vm.to_date_time = ""
                vm.meta.kg_strength = ""
                vm.meta.kg_strength_min = 0
                vm.meta.kg_strength_max = 1000
                vm.value = [vm.meta.kg_strength_min, vm.meta.kg_strength_max];
                vm.meta.pincode = '';
                vm.meta.place = '';
                vm.meta.is_latest = false;
                if (vm.$refs.flatpickr) {
                    vm.$refs.flatpickr.fp.setDate([]);
                }
                vm.$store.dispatch("resetReportSearch");
                vm.search();
            },
            selectSchool(e) {
                const school = e.target.value;
                this.meta.school_name = school.school_name;
                this.meta.school_id = school.school_id;
                // this.activity.asset_code = asset.asset_code;

            },
            checkInitalDistrict(e) {
                this.errors = [];
                if (e.target.value == 0) {
                    this.errors.district_error = "Please select district first"
                }
            },
            async activityRowsForExcel() {
                if (!this.staffMeta.from_date || !this.staffMeta.to_date) {
                    return [];
                }
                const userId = this.staffMeta.user_id || this.meta.user_id || "";
                const payload = {
                    search: this.staffMeta.search || "",
                    page: 1,
                    per_page: 10000,
                    from_date_time: moment(this.staffMeta.from_date).format("YYYY-MM-DD"),
                    to_date_time: moment(this.staffMeta.to_date).format("YYYY-MM-DD"),
                };
                if (userId) {
                    payload.user_id = userId;
                }
                const response = await this.$store.dispatch("post", { uri: "marketingActivity/paginateReportActivities", data: payload });
                const rows = response.data.data?.data || [];
                return rows.map((row, index) => ({
                    sr_no: index + 1,
                    user_id: row.user?.user_id || "",
                    user: row.user?.name || "",
                    session_started: this.formatSessionTime(row.session?.from_date_time) || "",
                    note: row.session?.note || row.activity?.note || "",
                    activity: row.activity?.activity_name || "",
                    status: row.activity?.status || "",
                    reminder: row.activity ? (this.formatReminder(row.activity.reminder) || "") : "",
                    activity_started: this.activityStarted(row.activity) || "",
                    activity_ended: this.activityEnded(row.activity) || "",
                    total_hours: this.activityTotalHours(row.activity) || "",
                }));
            },
            async downloadExcel() {
                try {
                    const activityRows = await this.activityRowsForExcel();
                    const response = await axios({
                        url: this.$store.getters.apiUrl + 'api/' + 'session/excelDownloadSessionForms', // Your Node.js server endpoint
                        method: 'POST',
                        responseType: 'blob', // Important to handle the file as a blob
                        headers: {
                            Authorization: "Bearer " + this.$store.getters.token, // Add the token from Vuex store
                        },
                        data: {
                            ...this.meta,
                            activity_rows: activityRows,
                        },
                    });

                    // Create a link element to download the file
                    const dateTime = moment().format('DD-MM-YYYY_HH-mm-ss');
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `session_report_${dateTime}.xlsx`); // Set the file name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    console.error('Error downloading the file', error);
                }
            }
        }
    };
</script>


<style scoped>
    /* .sticky-col {
        position: -webkit-sticky;
        position: sticky;
        background-color: #fff;
        z-index: 3;
        border-right: 1px solid #dee2e6;
    }

    .col-0 {
        left: 0;
        width: 50px;
    }

    .col-1 {
        left: 40px;
        width: 175px;
    }

    .col-2 {
        left: 165px;
        background-color: #fff;
        min-width: 550px;
    }

    .col-3 {
        left: calc(50px + 600px);
        width: 100px;
    }

    .table {
        table-layout: auto;
        width: 100%;
    }

    .table-responsive {
        overflow-x: auto;
    } */

     /* Ensure the first 4 columns are sticky */
    .sticky {
        position: sticky;
        left: 0;
        background-color: #fff; /* Optional: Adds a white background for better visibility */
        z-index: 1; /* Ensures the sticky columns stay above other columns */
    }

    /* Optional: Apply a background color for the header cells */
    .sticky-col {
        background-color: #f8f9fa; /* Light grey background */
    }

    /* Fix the sticky columns on scroll */
    .sticky-col.col-0 {
        left: 0;
        z-index: 2; /* Higher index for the first column */
    }

    .sticky-col.col-1 {
        left: 45px;
        z-index: 2;
    }

    .sticky-col.col-2 {
        left: 119px;
        z-index: 2;
        /* max-width: 521px;   */
    }

    .sticky-col.col-3 {
        left: 368px;
        z-index: 2;
    }

    .report-tabs {
        display: inline-flex;
        border: 1px solid #b7c3d0;
        border-radius: 8px;
        overflow: hidden;
        background: #fff;
    }
    .report-tab {
        border: 0;
        background: #fff;
        color: #334155;
        padding: 8px 18px;
        font-weight: 600;
        cursor: pointer;
    }
    .report-tab + .report-tab {
        border-left: 1px solid #b7c3d0;
    }
    .report-tab:hover:not(.active) {
        background: #e8f0fe;
        color: #0d6efd;
    }
    .report-tab.active {
        background: #0d6efd;
        color: #fff;
    }
    .staff-filters {
        position: relative;
        z-index: 3;
        overflow: visible;
    }
    table th, table td {
        padding: 6px 10px;
        /* border: 1px solid #dee2e6; */
    }
    .text-wrap {
        /* word-wrap: break-word; */
        /* word-break: break-word; */
        /* white-space: normal; */
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        /* overflow: hidden; */
        /* text-overflow: ellipsis; */
        width: 250px; /* Adjust width to fit your layout */
    }
</style>